import type { ReactNode } from 'react'
import { useMe } from '../../hooks/useMe'
import { getToken } from '../../lib/auth'
import NotAuthorized from './NotAuthorized'

export default function SuperuserOnly({ children }: { children: ReactNode }) {
  const authed = Boolean(getToken())
  const { me, loading } = useMe(authed)

  if (!authed) return <NotAuthorized />
  if (loading) {
    return <div className="rounded-xl border border-white/10 p-4 text-white/70">Loading...</div>
  }
  if (!me?.is_superuser) return <NotAuthorized />

  return <>{children}</>
}
